/**
 * AutoImporting components
 * @param path
 * @returns {function(): *}
 */
const page = path => () => import(/* webpackChunkName: '' */ `./components/${path}`).then(m => m.default || m)

export const routes = [
    {
        path: '/keywords',
        name: 'Keywords',
        component: page('KeywordList'),
    },
    {
        path: '/keywords/:id',
        name: 'Show Keyword',
        component: page('KeywordView'),
        hidden: true
    }
]
